var map = {
	"./en/strings.json": [
		8554,
		554
	],
	"./es-419/strings.json": [
		806,
		806
	],
	"./ja/strings.json": [
		3372,
		372
	],
	"./ko/strings.json": [
		9199,
		199
	],
	"./pseudo/strings.json": [
		583,
		583
	],
	"./pt-BR/strings.json": [
		5320,
		320
	],
	"./zh-Hant/strings.json": [
		27,
		27
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2395;
module.exports = webpackAsyncContext;